import {ApolloClient, createHttpLink, from, InMemoryCache} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import { errorLink } from './errorLink';
import { getToken } from 'utils/auth';
import i18n from '../i18n';

// 创建HTTP链接
const httpLink = createHttpLink({
    uri: '/api/graphql',
});

// 认证 + 语言链接：每次请求注入 Authorization 与 language（PDA 扫描后端按此 header 渲染 i18n_config 文案）
const authLink = setContext((_, {headers}) => {
    // 获取本地存储的token
    const token = getToken();
    // i18next 的当前语言（可能是 zh-CN / en-US / es 等），后端 LangResolver 会归一化到 zh/en/es
    const language = i18n.language || 'en';

    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
            language,
        },
    };
});

// 创建Apollo Client实例
export const client = new ApolloClient({
    link: from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache({
        typePolicies: {
            PickupTaskAppointmentWithAddressType: {
                keyFields: ['id', 'taskId'], // 使用id和taskId组合作为缓存键
            },
        },
    }),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
        },
    },
});
